var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "-webkit-left" },
                          attrs: { span: 8 },
                        },
                        [
                          _c("div", { staticClass: "card-header" }, [
                            _c("h3", [_vm._v("Users")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "-webkit-right" },
                          attrs: { span: 16 },
                        },
                        [
                          _c("input", {
                            ref: "bulkSetPermissionFile",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", accept: "text/csv" },
                            on: { change: _vm.onUsersFileSelected },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "Assign Permission to Multiple Users at once",
                                placement: "right",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "5px" },
                                  attrs: { type: "primary", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addBulkItems({
                                        entity: "users",
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Upload File\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          [
                            _c(
                              "div",
                              { staticClass: "el-upload__tip" },
                              [
                                _vm._v(
                                  "\n                .csv file with upto 150 emails "
                                ),
                                _c("el-tooltip", [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    File must include required headers (columns):\n                    "
                                      ),
                                      _c(
                                        "ol",
                                        {
                                          staticStyle: {
                                            "padding-left": "15px",
                                          },
                                        },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              "email: user email or user id to be assigned permission to"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v(
                                              'action: can have values "assign" or "unassign"'
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                    Headers are case insensitive but ordered i.e. first header must be email and second action.\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "el-icon-info" }),
                                ]),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-row",
                          {
                            staticStyle: {
                              border: "dotted",
                              "border-radius": "5px",
                              color: "rgb(202, 202, 202)",
                              margin: "20px 0px 20px 0px",
                            },
                          },
                          [
                            _c(
                              "form",
                              {
                                attrs: {
                                  model: _vm.form,
                                  disabled: !_vm.form.name,
                                },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addItem({
                                      entity: "users",
                                      email: _vm.form.name,
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      "text-align": "-webkit-center",
                                    },
                                    attrs: { span: 4 },
                                  },
                                  [_c("p", [_vm._v(" Add User ")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticStyle: { "margin-top": "5px" },
                                    attrs: { span: 16 },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { "max-width": "400px" },
                                      attrs: {
                                        required: "",
                                        placeholder: "Input user or email",
                                        input: "string",
                                      },
                                      model: {
                                        value: _vm.form.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "name", $$v)
                                        },
                                        expression: "form.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 4 } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Add User",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                            attrs: {
                                              type: "primary",
                                              plain: "",
                                              disabled: !_vm.form.name,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem({
                                                  entity: "users",
                                                  email: _vm.form.name,
                                                })
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-top": "0px" } }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-footer",
                      staticStyle: { height: "240px", "overflow-y": "scroll" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "permissions-table-style",
                          attrs: { data: _vm.permission.users.entries },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "min-width": 40,
                              prop: "type",
                              label: "Email",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.email) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": 45,
                              prop: "type",
                              label: "Name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.last_name) +
                                        ", " +
                                        _vm._s(scope.row.first_name) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { "min-width": 15, label: "Action" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Remove User",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icon-row",
                                            on: {
                                              click: function ($event) {
                                                return _vm.OpenRemoveItemDialog(
                                                  "users",
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                              attrs: { icon: "trash" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h3", [_vm._v("Roles")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            border: "dotted",
                            "border-radius": "5px",
                            color: "rgb(202, 202, 202)",
                            margin: "20px 0px 20px 0px",
                          },
                        },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "-webkit-center" },
                              attrs: { span: 4 },
                            },
                            [_c("p", [_vm._v(" Add Role ")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "5px" },
                              attrs: { span: 16 },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Select a role",
                                    required: "",
                                  },
                                  on: { change: _vm.selectRole },
                                  model: {
                                    value: _vm.currentRole,
                                    callback: function ($$v) {
                                      _vm.currentRole = $$v
                                    },
                                    expression: "currentRole",
                                  },
                                },
                                _vm._l(_vm.allowedRoles, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Add Role",
                                    placement: "right",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-top": "5px" },
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        disabled: !_vm.selectedRole,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addItem({
                                            entity: "roles",
                                          })
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "0px" } }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-footer" },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "permissions-table-style",
                        attrs: { data: _vm.permission.roles },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            "min-width": 80,
                            prop: "type",
                            label: "Role",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.name) +
                                      "\n              "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            "min-width": 15,
                            prop: "type",
                            label: "Action",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Remove Role",
                                        placement: "right",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon-row",
                                          on: {
                                            click: function ($event) {
                                              return _vm.OpenRemoveItemDialog(
                                                "roles",
                                                scope.row.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticStyle: {
                                              "margin-left": "15px",
                                            },
                                            attrs: { icon: "trash" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Remove " + _vm.action,
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", { staticClass: "icon", attrs: { src: _vm.icons.warning } }),
          _vm._v(" "),
          _c("span", { staticClass: "dialog_title_style" }, [
            _vm._v(
              "Remove " +
                _vm._s(_vm.action.slice(0, -1)) +
                " assigned to permission?"
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.removeItem()
                    },
                  },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Unsuccessful Permission Requests",
            visible: _vm.unsuccessfulDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.unsuccessfulDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { margin: "20px" },
              attrs: { data: _vm.unsuccessfulBulkRequests },
            },
            [
              _c("el-table-column", {
                attrs: { property: "email", label: "Email", width: "200" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "action", label: "Action", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "error", width: "600", label: "Error" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }